import { QuoteError } from './errors/quote.js';
import { quoteWithLog } from './utils/quoteWithLog.js';

async function getQuote(params) {
    const result = await quoteWithLog(params.quoteParams, params.config);
    return handleQuoteResult(result, params.quoteParams);
}
function handleQuoteResult(result, quoteParams) {
    if (result == null) {
        throw new QuoteError({
            quote: null,
            quoteParams,
        });
    }
    const failedQuotes = [];
    const validQuotes = [];
    for (const q of result) {
        if (isValidQuote(q)) {
            validQuotes.push(q);
        }
        else {
            failedQuotes.push(q);
        }
    }
    const quoteKind = quoteParams.exact_amount_in !== null ? "exact_in" : "exact_out";
    const bestQuote = sortQuotes(validQuotes, quoteKind)[0];
    if (bestQuote != null) {
        return bestQuote;
    }
    const failedQuote = failedQuotes[0];
    if (failedQuote != null) {
        throw new QuoteError({
            quote: failedQuote,
            quoteParams,
        });
    }
    throw new QuoteError({
        quote: null,
        quoteParams,
    });
}
function sortQuotes(quotes, quoteKind) {
    return quotes.slice().sort((a, b) => {
        if (quoteKind === "exact_in") {
            // For exact_in, sort by `amount_out` in descending order
            if (BigInt(a.amount_out) > BigInt(b.amount_out))
                return -1;
            if (BigInt(a.amount_out) < BigInt(b.amount_out))
                return 1;
            return 0;
        }
        // For exact_out, sort by `amount_in` in ascending order
        if (BigInt(a.amount_in) < BigInt(b.amount_in))
            return -1;
        if (BigInt(a.amount_in) > BigInt(b.amount_in))
            return 1;
        return 0;
    });
}
function isValidQuote(quote) {
    return !("type" in quote);
}

export { getQuote };
//# sourceMappingURL=getQuote.js.map
